import { Link } from "react-router-dom";

export default function Datenschutz() {
  return (
    <div className="max-w-3xl mx-auto px-4 md:px-8 py-16 md:py-20" data-testid="datenschutz-page">
      <div className="text-[10px] uppercase tracking-[0.3em] text-slate-500 mb-4">
        <span className="divider-thin" />Rechtliches
      </div>
      <h1 className="font-heading font-bold text-3xl md:text-5xl tracking-tight text-slate-900 mb-3 leading-[1.05]">
        Datenschutz<span className="font-serif italic font-medium">erklärung</span>
      </h1>
      <p className="text-sm text-slate-500 mb-12">
        Stand: Juni 2026 · gemäß DSGVO (Verordnung (EU) 2016/679) und österreichischem DSG
      </p>

      <div className="space-y-10 text-sm text-slate-700 leading-relaxed">
        <Section title="1. Verantwortlicher im Sinne der DSGVO">
          <p>
            <strong className="text-slate-900">D.R Automobile</strong><br />
            Inhaber: D. R.<br />
            Ringgasse 6, 4840 Vöcklabruck, Österreich<br />
            Telefon: <a href="tel:+436677608726" className="text-slate-900 underline">+43 667 760 8726</a><br />
            E-Mail: <a href="mailto:kontakt@dr-automobile.at" className="text-slate-900 underline">kontakt@dr-automobile.at</a>
          </p>
          <p className="text-xs text-slate-500 mt-2">
            Ein Datenschutzbeauftragter ist gesetzlich nicht erforderlich, da die Voraussetzungen
            des Art. 37 DSGVO nicht erfüllt werden.
          </p>
        </Section>

        <Section title="2. Allgemeines zur Datenverarbeitung">
          <p>
            Wir verarbeiten personenbezogene Daten unserer Nutzer und Kunden grundsätzlich nur, soweit
            dies zur Bereitstellung einer funktionsfähigen Website sowie unserer Leistungen erforderlich ist.
            Die Verarbeitung erfolgt regelmäßig nur nach Einwilligung der Nutzer, zur Vertragserfüllung,
            zur Wahrung berechtigter Interessen oder aufgrund gesetzlicher Verpflichtungen.
          </p>
        </Section>

        <Section title="3. Datenverarbeitung im Einzelnen">
          <h3 className="font-medium text-slate-900 mt-4">3.1 Aufruf der Website (Server-Logs)</h3>
          <p>
            Beim Aufruf unserer Website werden vom Webserver automatisch folgende Daten temporär in einer
            Logdatei gespeichert:
          </p>
          <ul className="list-disc pl-5 space-y-1">
            <li>IP-Adresse (anonymisiert nach 24 Stunden)</li>
            <li>Datum und Uhrzeit der Anfrage</li>
            <li>aufgerufene URL und HTTP-Statuscode</li>
            <li>Browser-Typ, Betriebssystem und Referrer</li>
          </ul>
          <p className="mt-2">
            <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an
            IT-Sicherheit und stabilem Betrieb der Website).<br />
            <strong>Speicherdauer:</strong> maximal 30 Tage.
          </p>

          <h3 className="font-medium text-slate-900 mt-6">3.2 Kontaktformular und E-Mail-Anfragen</h3>
          <p>Wenn Sie uns über das Kontaktformular oder per E-Mail kontaktieren, verarbeiten wir:</p>
          <ul className="list-disc pl-5 space-y-1">
            <li>Name (Vor- und Nachname)</li>
            <li>E-Mail-Adresse</li>
            <li>Telefonnummer (optional)</li>
            <li>Nachrichteninhalt</li>
            <li>Falls vorhanden: ID des angefragten Fahrzeugs</li>
            <li>Zeitstempel der Anfrage</li>
          </ul>
          <p className="mt-2">
            <strong>Zweck:</strong> Bearbeitung Ihrer Anfrage und ggf. Vertragsanbahnung.<br />
            <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. b DSGVO (Vertrag/vorvertragliche Maßnahmen)
            sowie Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an Kundenkommunikation).<br />
            <strong>Speicherdauer:</strong> bis zum Abschluss der Bearbeitung, längstens 12 Monate. Bei
            Vertragsabschluss greifen die handels- und steuerrechtlichen Aufbewahrungsfristen (7 Jahre
            gemäß § 132 BAO bzw. § 212 UGB).
          </p>

          <h3 className="font-medium text-slate-900 mt-6">3.3 Administrativer Zugang (nur Inhaber)</h3>
          <p>
            Für die Verwaltung der Website ist ein passwortgeschützter Admin-Bereich vorhanden. Zur
            Authentifizierung wird ein JSON-Web-Token (JWT) im lokalen Speicher des Browsers des Inhabers
            gesetzt. Dieser Token enthält die Benutzer-ID und ein Ablaufdatum (24 Stunden).
          </p>
          <p>
            <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. f DSGVO (IT-Sicherheit).
          </p>
        </Section>

        <Section title="4. Cookies und lokaler Speicher">
          <p>Diese Website verwendet ausschließlich technisch notwendige Speichermechanismen — keinerlei Tracking-, Analyse- oder Marketing-Cookies.</p>
          <div className="overflow-x-auto mt-4">
            <table className="w-full text-xs border border-slate-200">
              <thead className="bg-slate-50 text-slate-600">
                <tr>
                  <th className="text-left p-2 border-b border-slate-200">Bezeichnung</th>
                  <th className="text-left p-2 border-b border-slate-200">Zweck</th>
                  <th className="text-left p-2 border-b border-slate-200">Speicherdauer</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="p-2 border-b border-slate-100 font-mono">dra_cookie_consent</td>
                  <td className="p-2 border-b border-slate-100">Speichert Ihre Cookie-Entscheidung</td>
                  <td className="p-2 border-b border-slate-100">12 Monate</td>
                </tr>
                <tr>
                  <td className="p-2 font-mono">dra_token</td>
                  <td className="p-2">Authentifizierung Admin-Login</td>
                  <td className="p-2">24 Stunden</td>
                </tr>
              </tbody>
            </table>
          </div>
          <p className="mt-3">
            Da ausschließlich technisch notwendige Cookies eingesetzt werden, ist eine Einwilligung gemäß
            § 96 Abs. 3 TKG bzw. Art. 5 Abs. 3 ePrivacy-Richtlinie nicht erforderlich. Sie können dennoch
            jederzeit über das Cookie-Banner Ihre Auswahl treffen.
          </p>
        </Section>

        <Section title="5. Empfänger der Daten / Auftragsverarbeiter">
          <p>
            Eine Übermittlung Ihrer personenbezogenen Daten an Dritte findet nur in folgenden Fällen statt:
          </p>
          <ul className="list-disc pl-5 space-y-1">
            <li><strong>Hosting-Provider</strong>: Die Website wird auf Servern eines IT-Dienstleisters innerhalb der EU gehostet (Auftragsverarbeitungsvertrag gemäß Art. 28 DSGVO).</li>
            <li><strong>Behörden</strong>: bei gesetzlicher Verpflichtung, z. B. Finanzamt, Zulassungsbehörde (KFZ-Zulassung).</li>
            <li><strong>Steuerberatung / Buchhaltung</strong>: ausschließlich rechnungsrelevante Daten im Rahmen gesetzlicher Aufbewahrungspflichten.</li>
          </ul>
          <p className="mt-2">Eine Übermittlung in Drittländer außerhalb des EWR findet <strong>nicht</strong> statt.</p>
        </Section>

        <Section title="6. Keine automatisierte Entscheidungsfindung und kein Profiling">
          <p>
            Es findet keine automatisierte Entscheidungsfindung im Sinne des Art. 22 DSGVO statt. Es wird
            kein Profiling vorgenommen.
          </p>
        </Section>

        <Section title="7. Speicherdauer und Löschung">
          <p>
            Personenbezogene Daten werden gespeichert, solange dies zur Erfüllung des jeweiligen Zwecks
            erforderlich ist bzw. gesetzliche Aufbewahrungsfristen dies vorschreiben (insb. § 132 BAO,
            § 212 UGB: 7 Jahre für Geschäftsunterlagen). Nach Ablauf werden die Daten unverzüglich gelöscht
            oder anonymisiert.
          </p>
        </Section>

        <Section title="8. Ihre Rechte als betroffene Person">
          <p>Sie haben gegenüber dem Verantwortlichen folgende Rechte:</p>
          <ul className="list-disc pl-5 space-y-1">
            <li><strong>Auskunft</strong> über die zu Ihnen gespeicherten Daten (Art. 15 DSGVO)</li>
            <li><strong>Berichtigung</strong> unrichtiger Daten (Art. 16 DSGVO)</li>
            <li><strong>Löschung</strong> Ihrer Daten (Art. 17 DSGVO) — soweit keine gesetzlichen Aufbewahrungspflichten entgegenstehen</li>
            <li><strong>Einschränkung</strong> der Verarbeitung (Art. 18 DSGVO)</li>
            <li><strong>Datenübertragbarkeit</strong> (Art. 20 DSGVO)</li>
            <li><strong>Widerspruch</strong> gegen die Verarbeitung (Art. 21 DSGVO)</li>
            <li><strong>Widerruf</strong> einer erteilten Einwilligung mit Wirkung für die Zukunft (Art. 7 Abs. 3 DSGVO)</li>
          </ul>
          <p className="mt-3">
            Zur Ausübung Ihrer Rechte genügt eine formlose Mitteilung an{" "}
            <a href="mailto:kontakt@dr-automobile.at" className="text-slate-900 underline">kontakt@dr-automobile.at</a>.
            Die Bearbeitung erfolgt unverzüglich, spätestens innerhalb eines Monats (Art. 12 Abs. 3 DSGVO).
          </p>
        </Section>

        <Section title="9. Beschwerderecht bei der Aufsichtsbehörde">
          <p>
            Unbeschadet eines anderweitigen Rechtsbehelfs steht Ihnen das Recht zu, Beschwerde bei einer
            Aufsichtsbehörde — insbesondere in dem Mitgliedstaat Ihres Aufenthaltsorts, Ihres Arbeitsplatzes
            oder des Orts des mutmaßlichen Verstoßes — einzulegen (Art. 77 DSGVO).
          </p>
          <p className="mt-3">
            <strong>Österreichische Datenschutzbehörde (DSB)</strong><br />
            Barichgasse 40–42, 1030 Wien<br />
            Telefon: +43 1 52 152-0<br />
            E-Mail: <a href="mailto:dsb@dsb.gv.at" className="text-slate-900 underline">dsb@dsb.gv.at</a><br />
            Web: <a href="https://www.dsb.gv.at" target="_blank" rel="noopener noreferrer" className="text-slate-900 underline">www.dsb.gv.at</a>
          </p>
        </Section>

        <Section title="10. Datensicherheit (SSL/TLS)">
          <p>
            Diese Website nutzt aus Sicherheitsgründen und zum Schutz der Übertragung personenbezogener
            Daten eine TLS/SSL-Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie am Schloss-Symbol
            in Ihrer Browser-Adressleiste sowie am „https://" vor der Adresse.
          </p>
        </Section>

        <Section title="11. Änderungen dieser Datenschutzerklärung">
          <p>
            Wir behalten uns vor, diese Datenschutzerklärung anzupassen, damit sie stets den aktuellen
            rechtlichen Anforderungen entspricht oder um Änderungen unserer Leistungen umzusetzen. Es gilt
            jeweils die zum Zeitpunkt Ihres Besuchs abrufbare Fassung.
          </p>
        </Section>

        <div className="pt-6 border-t border-slate-200 text-xs text-slate-500">
          Weiterführende Informationen finden Sie in unseren{" "}
          <Link to="/agb" className="underline text-slate-900">AGB</Link> und im{" "}
          <Link to="/impressum" className="underline text-slate-900">Impressum</Link>.
        </div>
      </div>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <section>
      <h2 className="font-heading font-semibold text-lg text-slate-900 mb-3">{title}</h2>
      <div className="space-y-3">{children}</div>
    </section>
  );
}
